var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"color-light-grey pt-3 pb-3",attrs:{"fluid":"fluid"}},[_vm._v(" Text aus einer überschriebenen Component. ")])
}
var staticRenderFns = []

export { render, staticRenderFns }